import { energyType, mode } from '~/helpers/fields-description';
import { LegrandModule } from './LegrandModule.model';


export class NLPC extends LegrandModule {
    measures_scope?: string;
    measured_elec_type?: string;

    get fieldMode() {
        return mode(this.measures_scope);
    }
    get fieldEnergyType() {
        return energyType(this.measured_elec_type);
    }
}
